import { Chatbot } from "../../../../model/chatbot/Chatbot";

type ProviderGroup = {
  providerKey: string;
  providerLabel: string;
  models: Array<{ value: string; label?: string }>;
};

export type FaqPair = { question: string; answer: string };

export const formatFaqPairs = (
  pairs: FaqPair[] = [],
): Chatbot["aiConfig"]["aiFAQs"] =>
  pairs
    .map((p) => ({
      q: (p.question ?? "").trim(),
      a: (p.answer ?? "").trim(),
    }))
    .filter((p) => p.q.length || p.a.length)
    .map((p) => [p.q, p.a]);

export const AI_PROVIDER_MODELS: ProviderGroup[] = [
  {
    providerKey: "openai",
    providerLabel: "OpenAI",
    models: [
      {
        value: "gpt-5.5-pro",
        label: "ai-models.gpt-5.5-pro.label", //  "GPT-5.5 Pro (Best Quality)"
      },
      {
        value: "gpt-5.5",
        label: "ai-models.gpt-5.5.label", // GPT-5.5 (Balanced)
      },
      { value: "gpt-5.4-mini", label: "ai-models.gpt-5.4-mini.label" }, // GPT-5.4 Mini (Fast & Cheap)
      // { value: "gpt-5.5-pro", label: "GPT-5.5 Pro" },
      // { value: "gpt-5.5", label: "GPT-5.5" },
      // { value: "gpt-5.4-pro", label: "GPT-5.4 Pro" },
      // { value: "gpt-5.4", label: "GPT-5.4" },
      // { value: "gpt-5.4-mini", label: "GPT-5.4 Mini" },
      // { value: "gpt-5.4-nano", label: "GPT-5.4 Nano" },
      // { value: "gpt-5-mini", label: "GPT-5 Mini" },
      // { value: "gpt-5-nano", label: "GPT-5 Nano" },
      // { value: "gpt-5", label: "GPT-5" },
      // { value: "gpt-4.1", label: "GPT-4.1" },

      // { value: "gpt-4o", label: "GPT-4o" },
      // { value: "gpt-4o-mini", label: "GPT-4o Mini" },
      // { value: "gpt-4-turbo", label: "GPT-4 Turbo" },
      // { value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo (legacy)" },
    ],
  },
  // {
  //   providerKey: "anthropic",
  //   providerLabel: "Anthropic",
  //   models: [
  //     { value: "claude-opus-4-7", label: "Claude Opus 4.7" },
  //     { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6" },
  //     { value: "claude-haiku-4-5", label: "Claude Haiku 4.5" },
  //   ],
  // },
  // {
  //   providerKey: "google",
  //   providerLabel: "Google (Gemini)",
  //   models: [
  //     { value: "gemini-3.1-pro-preview", label: "Gemini 3.1 Pro Preview" },
  //     { value: "gemini-3-flash-preview", label: "Gemini 3.1 Flash Preview" },
  //     {
  //       value: "gemini-3.1-flash-lite-preview",
  //       label: "Gemini 3.1 Flash Lite Preview",
  //     },
  //     { value: "gemini-2.5-pro", label: "Gemini 2.5 Pro" },
  //     { value: "gemini-2.5-flash", label: "Gemini 2.5 Flash" },
  //   ],
  // },
];

export const providerLabelByModel = new Map<string, string>(
  AI_PROVIDER_MODELS.flatMap((p) =>
    p.models.map((m) => [m.value, p.providerLabel] as const),
  ),
);
